/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-08 12:37:00
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import { capitalizeFirstLetter } from 'src/helpers';

export const LIMIT_FILTER_OPTIONS = 30;
export const NUMBER_DEFAULT_FILTER = 2;
export const NUMBER_FILTER_TREE_PER_PAGE = 10;
export const ALL_VALUES_FILTER_OPTION = 'AdminHTML.FilterTree.Constant.allValuesFilterOption';
export const FAKED_PRODUCT_COUNT = 100;
export const MAX_TAG_LEVEL = 3;
export const MAX_COLLECTION_SUB_TAG_LEVEL = 2;

export const FILTER_TREE_MESSAGE = {
  ACTIVE_FILTER_SUCCESS: 'AdminHTML.FilterTree.Constant.filterTreeMessage1',
  ACTIVE_FILTER_FAILED: 'AdminHTML.FilterTree.Constant.filterTreeMessage2',
  DISABLE_FILTER_SUCCESS: 'AdminHTML.FilterTree.Constant.filterTreeMessage3',
  DISABLE_FILTER_FAILED: 'AdminHTML.FilterTree.Constant.filterTreeMessage4',
  DELETE_FILTER_SUCCESS: 'AdminHTML.FilterTree.Constant.filterTreeMessage5',
  DELETE_FILTER_FAILED: 'AdminHTML.FilterTree.Constant.filterTreeMessage6'
};

export const FILTER_TYPE = {
  COLLECTION: 'collection',
  VENDOR: 'vendor',
  PRODUCT_TYPE: 'product_type',
  PRODUCT_CATEGORY: 'product_category',
  PRICE: 'price',
  VARIANTS_PRICE: 'variants_price',
  PERCENT_SALE: 'percent_sale',
  REVIEW_RATINGS: 'review_ratings',
  STOCK_STATUS: 'stock',
  LOCATION: 'location',
  TAG: 'tag',
  MULTI_LEVEL_TAG: 'multi_level_tag',
  OPTION: 'opt_',
  METAFIELD: 'metafield_',
  WEIGHT: 'weight',
  RANGE_SLIDER: 'range_slider',
  VARIANTS_RANGE_SLIDER: 'variants_range_slider'
};

export const FILTER_TREE_DEFAULT_OPTION_TYPES = [
  {
    value: 'collection',
    label: 'AdminHTML.FilterTree.Common.collection',
    prefix: 'c',
    multiple: false
  },
  {
    value: 'vendor',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType2_Label',
    prefix: 'v',
    multiple: false
  },
  {
    value: 'product_type',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType3_Label',
    prefix: 'pt',
    multiple: false
  },
  {
    value: 'product_category',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType13_Label',
    prefix: 'pc',
    multiple: false
  },
  {
    value: 'price',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType4_Label',
    prefix: 'p',
    multiple: false
  },
  {
    value: 'variants_price',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType5_Label',
    prefix: 'vp',
    multiple: false
  },
  {
    value: 'percent_sale',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType6_Label',
    prefix: 'ps',
    multiple: false
  },
  {
    value: 'review_ratings',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType7_Label',
    prefix: 'r',
    multiple: false
  },
  {
    value: 'stock',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType8_Label',
    prefix: 'st',
    multiple: false
  },
  {
    value: 'location',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType12_Label',
    prefix: 'l',
    multiple: false
  },
  {
    value: 'tag',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType9_Label',
    prefix: 't',
    multiple: true
  },
  {
    value: 'multi_level_tag',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType10_Label',
    prefix: 'mlt',
    multiple: true
  },
  {
    value: 'weight',
    label: 'AdminHTML.FilterTree.Constant.defaultOptionType11_Label',
    prefix: 'w',
    multiple: false
  }
];

export const FILTER_TREE_SHOW_MORE_TYPE = [
  { value: 'scrollbar', label: 'AdminHTML.FilterTree.Constant.showMoreType1_Label' },
  { value: 'none', label: 'AdminHTML.FilterTree.Constant.showMoreType2_Label' },
  { value: 'viewmore', label: 'AdminHTML.FilterTree.Constant.showMoreType3_Label' },
  { value: 'viewmore_scrollbar', label: 'AdminHTML.FilterTree.Constant.showMoreType4_Label' }
];

export const FILTER_TREE_ADVANCED_SORT_TYPE = [
  { value: 'key-asc', label: 'AdminHTML.FilterTree.Constant.advancedSortType1_Label' },
  { value: 'key-desc', label: 'AdminHTML.FilterTree.Constant.advancedSortType2_Label' },
  { value: 'doc_count-asc', label: 'AdminHTML.FilterTree.Constant.advancedSortType3_Label' },
  { value: 'doc_count-desc', label: 'AdminHTML.FilterTree.Constant.advancedSortType4_Label' }
];

export const FILTER_OPTION_DEFAULT_VALUES = {
  // General
  optionType: null,
  optionLabel: '',
  // Collection
  collectionDisplayType: 'list',
  collectionOptionValues: 'all',
  collectionManualValues: [],
  collectionExcludedValues: [],
  collectionSubCategory: [{}],
  collectionMultiLevelManualValues: [
    {
      handle: '',
      value: '',
      label: '',
      displayName: '',
      tags: [
        {
          tag: '',
          displayName: ''
        }
      ],
      expanded: true // Expand automatically list of tag
    }
  ],
  collectionActiveCollectionAll: false,
  collectionKeepValuesStatic: false,
  // Vendor
  vendorDisplayType: 'list',
  vendorOptionSelect: 'single',
  vendorOptionValues: 'all',
  vendorManualValues: [],
  vendorExcludedValues: [],
  // Product type
  productTypeDisplayType: 'list',
  productTypeOptionSelect: 'single',
  productTypeOptionValues: 'all',
  productTypeManualValues: [],
  productTypeExcludedValues: [],
  // Product category
  productCategoryDisplayType: 'list',
  productCategoryOptionSelect: 'single',
  productCategoryOptionValues: 'all',
  productCategoryManualValues: [],
  productCategoryExcludedValues: [],
  // Location
  locationInventoryStatus: 'variant_quantity',
  locationDisplayType: 'list',
  locationOptionSelect: 'single',
  locationOptionValues: 'available_sale_online',
  locationManualValues: [],
  locationExcludedValues: [],
  locationNonFulfillmentValues: [],
  locationInventoryBaseSelectedLocations: false,
  // Tag
  tagDisplayType: 'list',
  tagSwatchStyle: 'circle-grid',
  tagOptionSelect: 'single',
  tagOptionValues: 'all',
  tagPrefix: false,
  tagPrefixValue: '',
  tagManualValues: [],
  tagExcludedValues: [],
  // Multi-level tags
  multiLevelTagOptionSelect: 'single',
  multiLevelTagManualValues: [
    {
      tag: '',
      displayName: ''
    }
  ],
  //Price
  priceDisplayType: 'range',
  priceSliderRange: 4,
  priceSliderStep: 1,
  priceSliderDelimiter: null,
  priceHideTextBoxes: false,
  priceList: [{ to: 10 }],
  priceExcludePriceFromValue: false,
  priceShortenPipsRange: false,
  // Variant's price
  variantsPriceDisplayType: 'range',
  variantsPriceSliderRange: 4,
  variantsPriceSliderStep: 1,
  variantsPriceSliderDelimiter: null,
  variantsPriceHideTextBoxes: false,
  variantsPriceList: [{ to: 10 }],
  variantsPriceExcludePriceFromValue: false,
  variantsPriceShortenPipsRange: false,
  // Percent sale
  percentSaleList: [{ to: 10 }],
  percentSaleExcludePriceFromValue: false,
  // Review ratings,
  reviewRatingsDisplayType: 'seleted_ratings_and_above',
  reviewRatingsOptionSelect: 'single',
  // Stock status
  stockStatusManualValues: [],
  stockStatusInStock: false,
  stockStatusOutOfStock: false,
  stockStatusInStockLabel: '',
  stockStatusOutOfStockLabel: '',
  // Weight
  weightSliderRange: 4,
  weightSliderStep: 1,
  weightSliderDelimiter: null,
  // Custom option
  opt_DisplayType: 'list',
  opt_SwatchStyle: 'circle-grid',
  opt_SelectType: 'single',
  opt_ValueType: 'all',
  opt_ManualValues: [],
  opt_ExcludedValues: [],
  // Metafield option
  metafield_DisplayType: 'list',
  metafield_SwatchStyle: 'circle-grid',
  metafield_SelectType: 'single',
  metafield_ValueType: 'all',
  metafield_ManualValues: [],
  metafield_ExcludedValues: [],
  // Advance
  isCollapseMobile: false,
  isCollapsePC: false,
  displayTooltip: false,
  displayAllValuesInUppercaseForm: false,
  showSearchBoxFilterMobile: false,
  showSearchBoxFilterPC: false,
  showMoreType: 'scrollbar',
  sortManualValues: false,
  sortType: 'key-asc',
  tooltip: '',
  //hidden value
  filterOptionId: '',
  position: '',
  status: 'active'
};

export function getFilterOptionDisplayTypes_Collection(
  multiLevelTagCollection: boolean,
  enabledAdvancedFilter
) {
  // if (
  //   window.location.href.indexOf('bc-sf-filter-demo') > -1 ||
  //   window.location.href.indexOf('bc-dev-v2' > -1) ||
  //   window.location.href.indexOf('homemartproducts.myshopify.com') > -1 ||
  //   window.location.href.indexOf('safarioutdoor.myshopify.com') > -1 ||
  //   window.location.href.indexOf('meshki-clothing.myshopify.com') > -1 ||
  //   window.location.href.indexOf('reddressboutique') > -1 ||
  //   window.location.href.indexOf('deeplorable') > -1 ||
  //   window.location.href.indexOf('photographsonline') > -1 ||
  //   window.location.href.indexOf('traderhank') > -1 ||
  //   window.location.href.indexOf('phonesmart-2') > -1
  // ) {
  //   displayTypes.push({
  //     value: 'sub_category',
  //     label: 'Sub-Category (Collection and tag as Sub-category)'
  //   });
  // }

  let displayTypes = [
    { value: 'list', label: 'AdminHTML.FilterTree.Constant.displayTypes1_Label' },
    {
      value: 'sub_category',
      label: 'AdminHTML.FilterTree.Constant.displayTypes2_Label'
    }
  ];

  // Create option Multi-level collections
  if (multiLevelTagCollection) {
    displayTypes = [{ value: 'list', label: 'AdminHTML.FilterTree.Constant.displayTypes3_Label' }];
    if (enabledAdvancedFilter) {
      displayTypes.push({
        value: 'multi_level_collections',
        label: 'AdminHTML.FilterTree.Constant.displayTypes4_Label'
      });
    }
  }

  return displayTypes;
}

export const FILTER_OPTION_DISPLAY_TYPES_DEFAULT = [
  { value: 'list', label: 'AdminHTML.FilterTree.Common.list' },
  { value: 'box', label: 'AdminHTML.FilterTree.Constant.displayTypesDefault2_Label' }
  // { value: 'swatch', label: 'Swatch' },
  // { value: 'range', label: 'Range' },
  // { value: 'rating', label: 'Rating' }
];

export const FILTER_OPTION_DISPLAY_TYPES_TAG = [
  ...FILTER_OPTION_DISPLAY_TYPES_DEFAULT,
  { value: 'swatch', label: 'AdminHTML.FilterTree.Common.swatch' }
];

export const FILTER_OPTION_DISPLAY_TYPES_MULTI_LEVEL_TAG = [{ value: 'list', label: 'List' }];

export const FILTER_OPTION_DISPLAY_TYPES_VENDOR = FILTER_OPTION_DISPLAY_TYPES_DEFAULT;

export const FILTER_OPTION_DISPLAY_TYPES_PRODUCT_TYPE = FILTER_OPTION_DISPLAY_TYPES_DEFAULT;

export const FILTER_OPTION_DISPLAY_TYPE_LOCATION = FILTER_OPTION_DISPLAY_TYPES_DEFAULT;

export const FILTER_OPTION_DISPLAY_TYPES_REVIEW_RATINGS = [
  {
    value: 'seleted_ratings_and_above',
    label: 'AdminHTML.FilterTree.Constant.displayTypesReviewRatings1_Label'
  },
  {
    value: 'selected_ratings_only',
    label: 'AdminHTML.FilterTree.Constant.displayTypesReviewRatings2_Label'
  }
];

export const FILTER_OPTION_INVENTORY_STATUS = [
  {
    value: 'variant_quantity',
    label: 'AdminHTML.FilterTree.Constant.inventoryStatusVariantQuantity'
  },
  {
    value: 'product_quantity',
    label: 'AdminHTML.FilterTree.Constant.inventoryStatusProductQuantity'
  }
];

export const FILTER_OPTION_DISPLAY_TYPES_PRICE = [
  { value: 'list', label: 'AdminHTML.FilterTree.Common.list' },
  { value: 'range', label: 'AdminHTML.FilterTree.Constant.displayTypesPrice2_Label' }
];

// Option display for filter option and metafield
export const FILTER_OPTION_DISPLAY_TYPES_OPTION_TYPE = [
  ...FILTER_OPTION_DISPLAY_TYPES_DEFAULT,
  { value: 'swatch', label: 'AdminHTML.FilterTree.Common.swatch' }
];

// Convert filter option type to a specific type
export function getFilterOptionValueTypes(type: string, locale: string, i18n: Object) {
  let origin_type = type;

  if (type !== null && _.startsWith(type, 'opt_')) {
    type = type.replace('opt_', '');
    type = capitalizeFirstLetter(type.replace(/_+/g, ' '), locale);
  }

  if (origin_type === 'weight' || origin_type.indexOf('range_slider') !== -1) {
    return [
      {
        value: 'all',
        label: i18n.translate('AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All', {
          nt_type_of_value: type
        })
      }
    ];
  }

  if (_.startsWith(origin_type, 'metafield_')) {
    type = i18n.translate('AdminHTML.FilterTree.Common.metafield');
  }

  if (origin_type === 'location') {
    return [
      {
        value: 'available_sale_online',
        label: i18n.translate(
          'AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_Available_Sale_Online'
        )
      },
      {
        value: 'all',
        label: i18n.translate(
          'AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All_Locations'
        )
      },
      {
        value: 'specific',
        label: i18n.translate('AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_ValueTypes2')
      }
    ];
  }

  var valueTypes = [
    {
      value: 'all',
      label: i18n.translate('AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All', {
        nt_type_of_value: getFilterOptionDisplayAll(type, i18n)
      })
    },
    {
      value: 'specific',
      label: i18n.translate('AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_ValueTypes2')
    }
  ];

  return valueTypes;
}

export const FILTER_OPTION_SELECT_TYPES = [
  { value: 'single', label: 'AdminHTML.FilterTree.Constant.selectTypes1_Label' },
  { value: 'multiple', label: 'AdminHTML.FilterTree.Constant.selectTypes2_Label' }
];

export const ADVANCED_FIELDS = [
  'isCollapseMobile',
  'isCollapsePC',
  'displayTooltip',
  'displayAllValuesInUppercaseForm',
  'showSearchBoxFilterMobile',
  'showSearchBoxFilterPC',
  'showMoreType',
  'sortManualValues',
  'sortType',
  'tooltip'
];

export const FILTER_OPTION_SWATCH_STYLES = [
  { value: 'circle-grid', label: 'AdminHTML.FilterTree.Constant.swatchStyle_Option1_Label' },
  { value: 'circle-list', label: 'AdminHTML.FilterTree.Constant.swatchStyle_Option2_Label' },
  { value: 'square-grid', label: 'AdminHTML.FilterTree.Constant.swatchStyle_Option3_Label' },
  { value: 'square-list', label: 'AdminHTML.FilterTree.Constant.swatchStyle_Option4_Label' }
];

const getFilterOptionDisplayAll = (type: string, i18n: Object) => {
  const mapOptionDisplay = {
    collection: i18n.translate(
      'AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All_Collection'
    ),
    vendor: i18n.translate('AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All_Vendor'),
    product_type: i18n.translate(
      'AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All_ProductType'
    ),
    product_category: i18n.translate(
      'AdminHTML.FilterTree.Constant.getFilterOptionValueTypes_All_ProductCategory'
    )
  };
  return mapOptionDisplay[type] ? mapOptionDisplay[type] : type;
};
